module.exports = __webpack_public_path__ + "static/SSL25565-fcc810c8c1b8642bc2cde722a37579ff.jpg";